var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGreenCheck = function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.768 1.232a2.5 2.5 0 010 3.536L12.1 19.434a2.5 2.5 0 01-3.535 0l-7.334-7.333a2.5 2.5 0 113.536-3.535l5.565 5.565 12.9-12.899a2.5 2.5 0 013.535 0z",
    fill: "#0D874C"
  })));
};
export default SvgGreenCheck;